import { type Locale, enUS as enUSLocale, es as esLocale, ptBR as ptBRLocale } from "date-fns/locale";

const dateLocales: { [key: string]: Locale } = { "pt-BR": ptBRLocale, "en-US": enUSLocale, "es-ES": esLocale };

const getLocale = (localeKey: string): Locale => dateLocales[localeKey] || dateLocales["en-US"];

export default getLocale;
